export default "__VITE_ASSET__DXnL_7kV__"